import MoveAndRotate from "./moveAndRotate";

class MoveModel extends MoveAndRotate {
    constructor(props) {
        super(props);
    }

    getComposedMatrix(model, idx) {
        const item = this.moveSteps[idx];
        const position = new THREE.Vector3(...item.position);
        const quaternion = new THREE.Quaternion(...item.quaternion);
        const scale = new THREE.Vector3(...item.scale);
        let composedMatrix = new THREE.Matrix4().compose(position, quaternion, scale);

        if (this.transitionValues) {
            composedMatrix.premultiply(model.matrix.clone());
        }

        return composedMatrix;
    }

    async stop(training) {
        this.cancelPendingMoveStepWait();
        const resourceId = training.resources[this.model.id].resourceId;
        CADModelTransformationAnimationManager.completeAndRemoveCurrentAnimationOfThisModel(resourceId);
    }

    async execute({training}) {
        const resourceId = training.resources[this.model.id].resourceId ||
            (training.resources[this.model.id]?.type === ResourceTypeEnum.HELPER_OBJECT && training.resources[this.model.id]?.id);
        const model = getModelObject(resourceId);

        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.MODEL, model.modelId);

        for (let i = 0; i < this.moveSteps.length; i++) {
            const array = this.getComposedMatrix(model, i).toArray();
            const pivot = this.getPivot(i);
            const animateTime = this.getAnimateTime(i);
            const animateMovement = animateTime > 0;

            if (animateMovement) {
                CADModelTransformationAnimationManager.transformModelWithAnimation(resourceId, array, undefined, animateTime, pivot);
            } else {
                CADModelTransformationAnimationManager.transformModelWithoutAnimation(resourceId, array);
            }

            if (animateMovement && i < this.moveSteps.length - 1) {
                if (await this._waitMoveStep(animateTime + 20)) {
                    return;
                }
            }
        }
    }
}

export default MoveModel;
